import http from '@/util/http.js'
const isLogin = false;
const nickName = "";
const headUrl = "";
const login = async function(code) {
  http.post('/user/login', { code: code }).then(res=> {
      if (res.code === 0) {
        this.isLogin = true;
        this.nickName = res.data.nickName;
        this.headUrl = res.data.headUrl;
      }
    }
  )
}
export default {
  isLogin, //用户token身份
  nickName,
  headUrl,
  login
}



// WEBPACK FOOTER //
// ./src/components/Global.js